// The Done panel a run ends on once "Complete run" has succeeded (ui-flow
// peak-end): what happened, one line of what the list already knows, and the
// next job. Presentation only — the mutation lives in Runs.tsx.
import SavedBanner, { SavedBannerButton } from '@/components/SavedBanner'

export interface RunCompleted {
  run_id: string
  run_number: string
  pallet_count: number
  packed_weight_kg: number
}

export function RunCompleteDone({ done, onVerify, onDismiss }: {
  done: RunCompleted
  /** Opens the run, where the Verify & publish card is. */
  onVerify: () => void
  onDismiss: () => void
}) {
  const pallets = `${done.pallet_count} pallet${done.pallet_count === 1 ? '' : 's'}`
  const kg = `${Math.round(done.packed_weight_kg).toLocaleString('en-ZA')} kg packed`
  return (
    <div className="px-4 pt-3">
      <SavedBanner onDismiss={onDismiss}
        title={`Run ${done.run_number} completed`}
        actions={<SavedBannerButton onClick={onVerify}>Verify &amp; publish →</SavedBannerButton>}>
        <p className="tabular-nums">{pallets} · {kg}</p>
      </SavedBanner>
    </div>
  )
}
